import type { CreateProblemCardBody } from '@/shared/lib/apiTypes'

export type ImpactScope = NonNullable<CreateProblemCardBody['impactScope']>
export type DesiredPeriod = NonNullable<CreateProblemCardBody['desiredPeriod']>

export const IMPACT_SCOPES: { value: ImpactScope; label: string }[] = [
  { value: 'personal', label: '나 한 사람' },
  { value: 'neighbor', label: '이웃 몇 사람' },
  { value: 'dong_wide', label: '동네 전체' },
]

export const DESIRED_PERIODS: { value: DesiredPeriod; label: string }[] = [
  { value: 'immediate', label: '지금 당장' },
  { value: 'within_3m', label: '3개월 안' },
  { value: 'within_6m', label: '6개월 안' },
  { value: 'anytime', label: '언제든' },
]

export const URGENCIES = [
  { value: 'high', label: '시급' },
  { value: 'mid', label: '보통' },
  { value: 'low', label: '여유' },
] as const

const toLabelMap = (list: readonly { value: string; label: string }[]): Record<string, string> =>
  Object.fromEntries(list.map((o) => [o.value, o.label]))

export const IMPACT_SCOPE_LABEL = toLabelMap(IMPACT_SCOPES)
export const DESIRED_PERIOD_LABEL = toLabelMap(DESIRED_PERIODS)

export const UNKNOWN_FIELD = {
  category: 'category_codes',
  helpType: 'help_type_codes',
  impactScope: 'impact_scope',
  desiredPeriod: 'desired_period',
  barrier: 'barrier_note',
  neededResource: 'needed_resource_note',
} as const
